var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnhancement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7.71 7.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5bbb70;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,3.2s.02-.1,.04-.14c.06-.2,.17-.37,.33-.5C1.31,1.79,2.26,1.02,3.2,.25c.28-.22,.58-.31,.93-.2,.12,.04,.24,.11,.34,.19,.96,.78,1.92,1.56,2.87,2.34,.25,.21,.38,.47,.37,.8-.02,.66-.73,1.1-1.33,.83-.09-.04-.18-.1-.26-.16-.74-.6-1.48-1.2-2.21-1.8-.02-.02-.04-.03-.07-.05-.21,.17-.41,.33-.61,.5-.55,.45-1.1,.9-1.65,1.35-.55,.44-1.33,.22-1.54-.44C.03,3.53,.01,3.48,0,3.42c0-.08,0-.15,0-.23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,6.54c.02-.07,.04-.15,.06-.22,.06-.16,.16-.3,.3-.41,.95-.78,1.91-1.56,2.86-2.33,.39-.32,.87-.31,1.26,0,.94,.77,1.88,1.54,2.83,2.3,.27,.22,.42,.49,.4,.83-.02,.36-.2,.64-.53,.8-.32,.16-.65,.15-.94-.06-.32-.23-.62-.49-.92-.74-.47-.38-.94-.77-1.41-1.15-.02-.02-.04-.03-.06-.05-.2,.16-.4,.33-.6,.49-.55,.45-1.1,.9-1.66,1.35-.55,.45-1.34,.23-1.54-.44C.03,6.88,.01,6.82,0,6.77v-.23Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnhancement);
export default __webpack_public_path__ + "static/media/Enhancement.712599e7a7d9b35a3e842c15a837e073.svg";
export { ForwardRef as ReactComponent };